import React, { Component } from "react";
import MediumSpacer from "../../components/MediumSpacer";
import { ApiConfig, API_URL } from "./../../settings";
import ReactMarkdown from "react-markdown";
import EraPreviewBox from "../../components/EraPreviewBox";
import ShareButtons from "../../components/ShareButtons";
import LoadingBox from "./../../components/LoadingBox";
import { updateCanonicalLink } from "../../helpers/helpers";
import axios from "axios";

export default class Article extends Component {
    constructor(props) {
        super(props);

        this.state = {
            article: null,
            churches: [],
            error: false,
            loading: true,
        };
    }
    async componentDidMount() {
        try {
            this.setState({ loading: true });

            await axios
                .get(`${API_URL}/api/articles/${this.props.match.params.id}`, ApiConfig)
                .then((response) => {
                    this.setState({
                        article: response.data.fields,
                        churches: response.data.fields.connectedChurch.map((i) => i.fields),
                        error: false,
                    });
                })
                .catch((error) => {
                    console.error(error);
                    this.setState({ error: true });
                })
        } finally {
            this.updatePageMeta(this.state.article);
            updateCanonicalLink();
            this.setState({ loading: false });
        }
    }

    updatePageMeta(article) {
        if (article.title){
            document.title = article.title;
            let titleOgTag = document.querySelector("meta[property='og:title']");
            titleOgTag.setAttribute('content', article.title);
        }  
    }

    render() {
        let { error, article, churches, loading } = this.state;

        if (error) {
            return (
                <div className="container">
                    <MediumSpacer />
                    <p>Det oppstod en feil. Prøv å laste siden på nytt.</p>
                    <MediumSpacer />
                </div>
            );
        }

        if (loading) {
            return (
                <div>
                    <MediumSpacer />
                    <LoadingBox text="Laster artikkel..." />
                    <MediumSpacer />
                </div>
            );
        }

        return (
            <div className="container short-story">
                <MediumSpacer />
                <h1 className="short-story__page-title ">{article.title}</h1>
                <MediumSpacer />

                {article.hasOwnProperty("images") && (
                    <div className="featured-image">
                        <div className="featured-image__inner">
                            <img
                                src={article.images[0].fields.file.url}
                                alt="Uthevet bilde for artikkelen"
                            />
                        </div>
                    </div>
                )}
                <MediumSpacer />

                <ShareButtons />

                <MediumSpacer />

                <div className="container reading content-columns">
                    {article.hasOwnProperty("author") && (
                        <p className="short-story__author">
                            Tekst: {article.author}
                        </p>
                    )}

                    <div
                        style={{
                            margin: "1em 0",
                            fontSize: "1.15em",
                            fontWeight: "bold",
                        }}
                    >
                        <ReactMarkdown source={article.ingress} />
                    </div>

                    <ReactMarkdown source={article.body} />
                </div>

                <MediumSpacer />
                <h2>Kirker</h2>
                <div className="grid-column-3">
                    {churches.map((church) => {
                        return (
                            <EraPreviewBox
                                key={church.id}
                                title={church.name}
                                description={church.ingress}
                                image={church.mainimage}
                                link={"/kirke/" + church.id}
                            />
                        );
                    })}
                </div>
                <MediumSpacer />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/Article/index.js